module.exports = __webpack_public_path__ + "static/media/architect.6117bba6.svg";